module.exports = __webpack_public_path__ + "img/810.f6167b25.png";